import React, { useEffect, useState } from "react";
import { verifyUserCredentials } from "../../utils";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setShowError] = useState("hidden");

  useEffect(() => {
    try {
      const {email, password, user_type} = JSON.parse(localStorage.getItem("user"))
      const user = verifyUserCredentials(email, password);
      if (user) {
        // Redirect based on user type
        if (user_type === "admin") {
          navigate("/internal");
        } else {
          navigate("/staff");
        }
      }
    }
    catch (e) {
      console.log('no credentials found in local storage')
    }
  }, [navigate])

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = verifyUserCredentials(email, password);
    if (!user) {
      setShowError(() => "");
      setTimeout(() => {
        setShowError(() => "hidden");
      }, 5000);
      return;
    }
    localStorage.setItem("user", JSON.stringify({ email, password, user_type: user.user_type }));
    // Redirect based on user type
    if (user.user_type === "admin") {
      navigate("/internal");
    } else {
      navigate("/staff");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Login
        </h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <h6 className={`text-red-800 ${showError}`}>
              Incorrect email or password
            </h6>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-800 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Log In
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
